import React from 'react'
import PropTypes from 'prop-types'
import {AspectRatio, Box, Flex, Img, Text} from '@chakra-ui/react'
import useDamImage from '../../../../custom-hooks/use-dam-image'
import SanitizedHtml from '../../../html-sanitizer'

export const SortingTile = ({styles, tile, variant}) => {
    const damImage = useDamImage(tile.image)

    return (
        <Flex data-testid="sorting-tile" {...styles.tile}>
            {(damImage.url || tile.image?.alt) && (
                <AspectRatio ratio={damImage.ratio} {...styles.tileimage}>
                    <Img src={damImage.url} alt={tile.image?.alt || ''} />
                </AspectRatio>
            )}
            <Box
                textStyle="head-small"
                fontWeight={'medium'}
                color={variant === 'black' ? 'text.inverse' : 'text.default'}
                {...styles.tiletitle}
                className={'tile-title'}
            >
                {tile?.title && <Text>{tile?.title}</Text>}
            </Box>
            <SanitizedHtml
                as={Box}
                html={tile?.body_copy || ''}
                textStyle="body-medium"
                fontWeight={'normal'}
                color={variant === 'black' ? 'text.inverse' : 'text.default'}
                {...styles.tilebodycopy}
                className={'tile-bodycopy'}
            />
        </Flex>
    )
}

SortingTile.propTypes = {
    styles: PropTypes.shape(),
    tile: PropTypes.shape({
        title: PropTypes.string,
        body_copy: PropTypes.string,
        image: PropTypes.shape(),
        features: PropTypes.arrayOf(PropTypes.shape({feature: PropTypes.string})),
        cta: PropTypes.shape({title: PropTypes.string, href: PropTypes.string}),
    }),
    variant: PropTypes.string,
}
